import React, { memo } from 'react';

const Phone = memo(({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 2H7.5C6.39543 2 5.5 2.89543 5.5 4V20C5.5 21.1046 6.39543 22 7.5 22H16.5C17.6046 22 18.5 21.1046 18.5 20V4C18.5 2.89543 17.6046 2 16.5 2Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.0703 18.5601H13.9303"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.4098 2V3C15.4098 3.55 14.9598 4 14.4098 4H9.58984C9.03984 4 8.58984 3.55 8.58984 3V2H15.4098Z"
        fill="#A1A1A1"
        stroke="#A1A1A1"
        strokeMiterlimit="10"
      />
    </svg>
  );
});

export default Phone;
